import ReactPixel from "react-facebook-pixel";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";

export const trackMetaEvent = async (
  eventName,
  userData = {},
  customData = {}
) => {
  const eventId = uuidv4();

  // =========================
  // Browser Pixel
  // =========================
  ReactPixel.track(eventName, customData, {
    eventID: eventId,
  });

  // =========================
  // Meta Conversions API
  // =========================
  try {
    await axios.post(
      `${process.env.REACT_APP_API_URL}/api/meta-event`,
      {
        eventName,
        eventId,

        eventSourceUrl: window.location.href,

        clientUserAgent: navigator.userAgent,

        userEmail: userData.email || undefined,

        userPhone: userData.phone || undefined,

        customData,
      }
    );

    // console.log(
    //   `${eventName} sent to Meta CAPI`,
    //   eventId
    // );
  } catch (error) {
    console.error(
      `${eventName} CAPI Error:`,
      error.response?.data || error.message
    );
  }
};